import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';

@Component({
  selector: 'app-impaired-icon',
  templateUrl: './impaired-icon.component.html',
  styleUrls: ['./impaired-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImpairedIconComponent {
  @Input() public isIconDisabled = false;
  @Input() public iconName: CustomIcons = CustomIcons.BigTriangleDown;
  @Input() public classSize: 'medium-impaired' | 'small-impaired' | 'big-impaired' = 'medium-impaired';
  @Output() public readonly clickOnIcon = new EventEmitter();
  @Input() public invertColor = false;
}
